module.exports = __webpack_public_path__ + "img/FR-Wix-integration-vidjet-step3.4612f78e.png";